<template>
  <div :class="$style.detail">
    <info-card :info="info" />
    <div :class="$style.contentBox">
      <a-tabs
        :default-active-key="activeKey"
        :tabBarStyle="{ margin: '10px 20px' }"
        @change="changeTab"
      >
        <a-tab-pane key="cleaning-log">
          <span slot="tab">
            <a-badge
              :count="data.alarmCount"
              :number-style="{
                backgroundColor: 'var(--primary)',
                boxShadow: '0 0 0 1px var(--primary) inset',
                top: '-5px',
              }"
            >
              {{ $t('carManagement.carWashingMonitoring') }}
            </a-badge>
          </span>
          <cleaning-log
            v-if="activeKey === 'cleaning-log'"
            :deviceId="data.pkId"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator';
import CleaningLog from './cleaning-log.vue';
import InfoCard from '@/views/green-construction/components/info-card.vue';

@Component({
  components: {
    CleaningLog,
    InfoCard,
  },
})
export default class CleaningDetail extends Vue {
  @Prop({ type: Object, default: () => {} }) data;
  @Prop({ type: Function, default: () => {} }) close;
  get info() {
    return [
      {
        name: this.$t('safety.deviceName'),
        content: this.data.deviceName || '--',
      },
      {
        name: this.$t('safety.deviceCode'),
        content: this.data.deviceCode || '--',
      },
      {
        name: this.$t('safety.belongProject'),
        content: this.data.projectName || '--',
      },
      {
        name: this.$t('common.remark'),
        content: this.data.remark || '--',
      },
    ];
  }
  activeKey = 'cleaning-log';
  changeTab(activeKey) {
    this.activeKey = activeKey;
  }
}
</script>

<style lang="less" module>
.detail {
  padding-bottom: 0;
  padding-right: 0;
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: calc(100vh - 75px);
  .text {
    color: var(--font-title);
  }
  .textHidden {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .contentBox {
    .boxTitle {
      font-size: 14px;
      color: var(--font);
      padding: 0 20px 10px;
    }
  }
}
</style>
